import {
  actionRequestsActivityQuery,
  issueDeflectionActivityQuery,
  questionsActivityQuery,
} from "../lib/supportEntityActivityQueries"
import { useDashboardQuery } from "./useDashboardQuery"

export function useIssueDeflectionActivityQuery(
  ...args: Parameters<typeof issueDeflectionActivityQuery>
) {
  return useDashboardQuery(issueDeflectionActivityQuery(...args))
}

export function useQuestionsActivityQuery(...args: Parameters<typeof questionsActivityQuery>) {
  return useDashboardQuery(questionsActivityQuery(...args))
}

export function useActionRequestsActivityQuery(
  ...args: Parameters<typeof actionRequestsActivityQuery>
) {
  return useDashboardQuery(actionRequestsActivityQuery(...args))
}
